import { Navigate, Outlet } from "react-router-dom";
import TopNav from "./TopNav";
import SidebarMenu from "./SidebarMenu";
import Auth from "../../../auth/Auth";
;

export default function DashboardLayout() {
    return (
        <div className="dashboard_root">
            <SidebarMenu />

            <div className="topbar">
                <TopNav />
            </div>

            <div className="dashboard">
                {!Auth.isUserAuthenticated() ? <Navigate to="/login" /> : <Outlet />}

            </div>
        </div>
    );
}
